import { Application, EventEmitter } from "pixi.js";
import { ConfigParams } from "../GameConfig";
import Scene from "./Scene";

export const SceneManager = (app: Application, config: ConfigParams) => {
  const scenes: { [key: string]: Scene } = {};
  let hitScene: Scene | undefined = undefined;
  let advertScene: Scene | undefined = undefined;
  const playlist: string[] = [];

  let lastScene: string | null = null;
  let currentScene: string | null = null;

  const addScene = (
    scene: Scene,
    appendToPlaylist: boolean = true,
  ): boolean => {
    if (scene.name in scenes) {
      console.error(
        `Cannot add scene. Scene with name '${scene.name}' already exists.`,
      );
      return false;
    }

    scenes[scene.name] = scene;
    if (appendToPlaylist) playlist.push(scene.name);
    return true;
  };

  const setJackpotHitScene = (scene: Scene): void => {
    hitScene = scene;
  };

  const setAdvertScene = (scene: Scene): void => {
    advertScene = scene;
  };

  const removeScene = (sceneName: string): boolean => {
    if (!(sceneName in scenes)) {
      console.error(
        `Cannot remove scene. Scene with name '${sceneName}' not in scenes.`,
      );
      return false;
    }

    if (currentScene === sceneName) {
      scenes[sceneName].hide();
    }
    if (sceneName in playlist) playlist.splice(playlist.indexOf(sceneName), 1);
    const scene = scenes[sceneName];
    delete scenes[sceneName];

    if (!(sceneName in scenes)) {
      firstScene();
    }
    return true;
  };

  const firstScene = () => {
    if (Object.keys(scenes).length > 0) {
      const firstKey = Object.keys(scenes)[0];
      switchScene(firstKey);
    }
  };

  const nextScene = () => {
    if (Object.keys(scenes).length > 0) {
      const filteredScenes = Object;
      const firstKey = Object.keys(scenes)[0];
      switchScene(firstKey);
    }
  };

  const switchScene = (sceneName: string) => {
    if (currentScene === sceneName) {
      console.log(
        `Cannot switch scene. Scene with name '${sceneName}' is already playing.`,
      );
      return;
    }
    if (!(sceneName in scenes)) {
      console.log(
        `Cannot switch scene. Scene with name '${sceneName}' does not exist.`,
      );
      return;
    }

    if (advertScene !== undefined) {
      advertScene.hide();
    }
    if (hitScene !== undefined) {
      hitScene.hide();
    }

    for (const key in scenes) {
      const scene = scenes[key];
      if (key === sceneName) {
        scene.show();
        currentScene = scene.name;
      } else {
        scene.hide();
      }
    }
  };

  const playHitScene = () => {
    if (hitScene === undefined) {
      console.warn("Cannot switch scene. Jackpot hit scene does not exist.");
      return;
    }
    for (const key in scenes) {
      const scene = scenes[key];
      scene.hide();
    }
    if (advertScene !== undefined) {
      advertScene.hide();
    }

    hitScene.show();
    currentScene = hitScene.name;
  };

  const playAdverts = () => {
    if (advertScene === undefined) {
      console.warn("Cannot switch scene. Advert scene does not exist.");
      return;
    }
    for (const key in scenes) {
      const scene = scenes[key];
      scene.hide();
    }
    if (hitScene !== undefined) {
      hitScene.hide();
    }

    advertScene.show();
    currentScene = advertScene.name;
  };

  const getCurrentSceneName = (): string => {
    return currentScene ?? "";
  };

  const start = (): void => {
    firstScene();
  };

  return {
    start,
    addScene,
    setJackpotHitScene,
    setAdvertScene,
    removeScene,
    switchScene,
    firstScene,
    playHitScene,
    playAdverts,
    getCurrentSceneName,
  };
};
